import { environment } from '../../../environments/environment.local';

export const vesselUriTemplate = (vesselId?: number): string => {
  return `${environment.API.VESSELS_URI}/${vesselId}`;
};
